export default [
  {
    path: '/active-xy2024/index',
    name: 'index',
    component: () => import('@/views/active-xy2024/index'),
    meta: {
      title: '点亮2024心愿灯，攒福气值开除夕红包-高考直通车',
      content:'福气值满满，是有点幸运在身上的!看看你的除夕红包开到多少!'
    }
  },{
    path: '/active-xy2024/packet',
    name: 'index',
    component: () => import('@/views/active-xy2024/packet'),
    meta: {
      title: '点亮2024心愿灯，攒福气值开除夕红包-高考直通车',
      content:'福气值满满，是有点幸运在身上的!看看你的除夕红包开到多少!'
    }
  },{
    path: '/active-xy2024/money',
    name: 'money',
    component: () => import('@/views/active-xy2024/money'),
    meta: {
      title: '点亮2024心愿灯，攒福气值开除夕红包-高考直通车',
      content:'福气值满满，是有点幸运在身上的!看看你的除夕红包开到多少!'
    }
  },{
    path: '/active-xy2024/record',
    name: 'record',
    component: () => import('@/views/active-xy2024/record'),
    meta: {
      title: '点亮2024心愿灯，攒福气值开除夕红包-高考直通车',
      content:'福气值满满，是有点幸运在身上的!看看你的除夕红包开到多少!'
    }
  },{
    path: '/active-xy2024/examine',
    name: 'examine',
    component: () => import('@/views/active-xy2024/examine'),
    meta: {
      title: '点亮2024心愿灯，攒福气值开除夕红包-高考直通车',
      content:'福气值满满，是有点幸运在身上的!看看你的除夕红包开到多少!'
    }
  },{
    path: '/active-xy2024/makewish',
    name: 'makewish',
    component: () => import('@/views/active-xy2024/makewish'),
    meta: {
      title: '点亮2024心愿灯，攒福气值开除夕红包-高考直通车',
      content:'福气值满满，是有点幸运在身上的!看看你的除夕红包开到多少!'
    }
  }
]
